// extracted by css-extract-rspack-plugin
export default {"emptyBox":"empty-box__FBpl","emptyText":"empty-text_zFX8C"};